import { Typography, Grid, Box } from "@mui/material";
import React from "react";
import "./skill.css";
import Button from "../globalComponent/Button/Button";
import Button2 from "../globalComponent/Button2/Button2";

function Skill() {
  return (
    <div className="skill_section">
      <Typography
        variant="h4"
        component="div"
        align="center"
        sx={{
          color: "#fff",
          margin: "50px",
        }}>
        My Skills
      </Typography>

      {/* Languages */}
      <Typography
        align="center"
        component="div"
        sx={{ color: "#fff", fontSize: "18px", margin: "20px auto" }}>
        Languages
      </Typography>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Box
          component={Grid}
          display={{ xs: "none", md: "block" }}
          item
          xs={0}
          lg={1}
          md={1.5}
          align="center"></Box>
        <Grid item xs={6} lg={2} md={3} align="center">
          <Button
            name="C++"
            logo="https://img.icons8.com/ios/32/ffffff/c-plus-plus-logo.png"></Button>
        </Grid>
        <Grid item xs={6} lg={2} md={3} align="center">
          <Button
            name="JAVA"
            logo="https://img.icons8.com/ios/32/ffffff/java-coffee-cup-logo--v1.png"></Button>
        </Grid>
        <Grid item xs={6} lg={2} md={3} align="center">
          <Button
            name="Python"
            logo="https://img.icons8.com/ios-filled/32/ffffff/python.png"></Button>
        </Grid>
        <Box
          component={Grid}
          item
          xs={0}
          lg={0}
          md={3}
          display={{ md: "block", lg: "none", xs: "none" }}
          align="center"></Box>

        <Grid item xs={6} lg={2} md={3} align="center">
          <Button
            name="PHP"
            logo="https://img.icons8.com/ios-filled/32/ffffff/php-logo.png"></Button>
        </Grid>
        <Grid item xs={6} lg={2} md={3} align="center">
          <Button
            name="JavaScript"
            logo="https://img.icons8.com/ios-filled/32/ffffff/javascript.png"></Button>
        </Grid>
      </Grid>

      {/* TechSkills */}
      <Typography
        align="center"
        component="div"
        sx={{ color: "#fff", fontSize: "18px", margin: "40px 0px 20px auto" }}>
        Web. technologies
      </Typography>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={6} lg={2} md={4} align="center">
          <Button2
            name="HTML"
            logo="https://img.icons8.com/color/80/000000/html-5--v1.png"></Button2>
        </Grid>
        <Grid item xs={6} lg={2} md={4} align="center">
          <Button2
            name="CSS"
            logo="https://img.icons8.com/color/80/000000/css3.png"></Button2>
        </Grid>
        <Grid item xs={6} lg={2} md={4} align="center">
          <Button2
            name="ReactJs"
            logo="https://img.icons8.com/officel/80/ffffff/react.png"></Button2>
        </Grid>
        <Grid item xs={6} lg={2} md={4} align="center">
          <Button2
            name="Nodejs"
            logo="https://img.icons8.com/windows/80/ffffff/nodejs.png"></Button2>
        </Grid>
        <Grid item xs={6} lg={2} md={4} align="center">
          <Button2
            name="Mongodb"
            logo="https://img.icons8.com/color/80/000000/mongodb.png"></Button2>
        </Grid>
        <Grid item xs={6} lg={2} md={4} align="center">
          <Button2
            name="Graphql"
            logo="https://img.icons8.com/color/80/000000/graphql.png"></Button2>
        </Grid>
      </Grid>

      {/* Other Skills */}

      <Typography
        align="center"
        component="div"
        variant="h5"
        sx={{ color: "#fff", margin: "50px auto" }}>
        Other
      </Typography>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{ margin: "50px" }}>
        <Grid item xs={6} lg={6} align="center">
          <img src="https://img.icons8.com/ios-filled/80/ffffff/database.png" />
        </Grid>
        {/* <Grid item xs={3} align="center">
          <Typography variant="h5" color={"#fff"}>
            Data structure <br></br> {"&"} <br></br> Algorithm
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="h5" color={"#fff"}>
            Object Oriented <br></br> <br></br> Programming
          </Typography>
        </Grid> */}
        <Grid item xs={6} lg={6} align="center">
          <img src="https://img.icons8.com/ios-filled/80/ffffff/git.png" />
        </Grid>
      </Grid>
    </div>
  );
}

export default Skill;
